import React from 'react';
import TooltipCmp from 'src/components/TooltipCmp';
import { getShortName } from 'src/utils/CommonFunctions';

interface AvatarGroupProps {
    avatars: {
        src: string;
        alt: string;
    }[];
    maxVisible?: number;
}

export default function AvatarGroup({ avatars = [], maxVisible = 4 }: AvatarGroupProps) {
    const visibleAvatars = avatars.slice(0, maxVisible);
    const remainingCount = avatars.length - maxVisible;

    const hiddenAvatars = avatars.slice(maxVisible);
    const [imageErrors, setImageErrors] = React.useState<Record<number, boolean>>({});

    const handleImageError = (index: number) => {
        setImageErrors((prev) => ({ ...prev, [index]: true }));
    };

    return (
        <div className="flex items-center">
            <div className="flex -space-x-2">
                <div className="flex items-center [&>div:not(:first-child)>div>div]:border-white [&>div:not(:first-child)>div>div]:border-[1.5px] [&>div:not(:first-child)]:-ml-2">
                    {visibleAvatars.map((avatar, index) => (
                        <TooltipCmp message={`${avatar?.alt || 'Unknown'}`} key={index}>
                            <div className="rounded-full bg-white">
                                {avatar.src && !imageErrors[index] ? (
                                    <img
                                        src={avatar.src}
                                        alt={avatar.alt}
                                        className="table-profile-icn-circle-sm min-w-[24px] min-h-[24px] w-[24px] h-[24px]"
                                        onError={() => handleImageError(index)}
                                    />
                                ) : (
                                    <div className="table-profile-user-circle-xs">{getShortName(avatar?.alt || 'unassigned')}</div>
                                )}
                            </div>
                        </TooltipCmp>
                    ))}
                    {remainingCount > 0 && (
                        <TooltipCmp
                            parentClassName={`min-w-fit max-w-max w-full max-w-[240px]`}
                            position="top"
                            message={
                                <div>
                                    {hiddenAvatars.map((member: any, index: number) => (
                                        <span key={index} className="whitespace-nowrap">
                                            {member.alt}
                                            {index < hiddenAvatars.length - 1 && (
                                                <>
                                                    ,<br />
                                                </>
                                            )}
                                        </span>
                                    ))}
                                </div>
                            }
                        >
                            <div className="rounded-full bg-white">
                                <div
                                    className={`min-w-6 min-h-6 py-0.5 px-1 rounded-full bg-utilityGray100 text-grayLight600 text-[10px] leading-4 font-semibold flex items-center justify-center border border-utilityBlack border-opacity-[0.08]`}
                                >
                                    +{hiddenAvatars.length}
                                </div>
                            </div>
                        </TooltipCmp>
                    )}
                </div>
            </div>
        </div>
    );
}
